import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useCameraStream from '../../hooks/useCameraStream';

interface CameraPanelProps {
 cameraId?: number | null;
}

const CameraPanel = ({ cameraId }: CameraPanelProps) => {
 const { t } = useTranslation();
 const { status, name, error, videoRef, start } = useCameraStream(cameraId);

 return (
  <Box
   sx={{
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    minHeight: 160,
   }}
  >
   <Box
    sx={{
     display: 'flex',
     alignItems: 'center',
     justifyContent: 'space-between',
     gap: 1,
    }}
   >
    <Typography sx={{ fontSize: 14, fontWeight: 500 }} noWrap>
     {name || t('dashboard.cameras.placeholder')}
    </Typography>
    {!!cameraId && (
     <Button
      size="small"
      variant="outlined"
      onClick={start}
      disabled={status === 'loading'}
      title={t('dashboard.cameras.refresh')}
     >
      ↻ {t('dashboard.cameras.refresh')}
     </Button>
    )}
   </Box>

   {error && (
    <Typography sx={{ fontSize: 12, color: (th) => th.palette.kemek.red }}>
     {error}
    </Typography>
   )}

   {!cameraId ? (
    <Box
     sx={{
      flexGrow: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: (th) => th.palette.kemek.gray,
      fontSize: 14,
     }}
    >
     {t('dashboard.cameras.placeholder')}
    </Box>
   ) : (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
     ref={videoRef}
     controls
     autoPlay
     playsInline
     muted
     style={{ width: '100%', flexGrow: 1, background: '#000', minHeight: 160 }}
    />
   )}
  </Box>
 );
};

export default CameraPanel;
